var _path, _path2, _circle, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKeysetupone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 12.9999C1 10.9255 1.53775 8.88655 2.56077 7.08195C3.5838 5.27736 5.05716 3.76879 6.83709 2.70343C8.61702 1.63808 10.6427 1.05233 12.7166 1.00335C14.7904 0.954362 16.8415 1.44381 18.6697 2.42394",
    stroke: "#7647EE",
    strokeWidth: 0.888883
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9999 12.9998C24.9999 15.6148 24.1457 18.1583 22.5671 20.2433C20.9886 22.3282 18.7722 23.8404 16.2552 24.5497C13.7381 25.2591 11.0583 25.1268 8.62334 24.1731C6.18839 23.2193 4.13167 21.4962 2.76611 19.2659",
    stroke: "#7647EE",
    strokeWidth: 0.888883
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 12.9998,
    r: 10.2856,
    fill: "#1E016F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3896 17.7141V9.75988L10.8399 10.1164V9.04674L12.9656 8.11418H13.8982V17.7141H12.3896Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeysetupone);
export default __webpack_public_path__ + "static/media/keysetupone.d628b796e1c1e0ddf5509c523297f65d.svg";
export { ForwardRef as ReactComponent };